import { createContext, type ReactNode, useMemo } from 'react';

import { useRequiredContext } from 'hooks';
import type { CheckoutMachineActor } from 'state-machines/checkout';

interface CheckoutContextType {
	checkoutService: CheckoutMachineActor;
}

const CheckoutContext = createContext<CheckoutContextType | undefined>(
	undefined,
);

interface Props {
	checkoutService: CheckoutMachineActor;
	children: ReactNode;
}

export function CheckoutContextProvider({ checkoutService, children }: Props) {
	const checkoutContextValue = useMemo(
		() => ({ checkoutService }),
		[checkoutService],
	);
	return (
		<CheckoutContext value={checkoutContextValue}>{children}</CheckoutContext>
	);
}
CheckoutContextProvider.displayName = 'CheckoutContextProvider';

export function useCheckoutContext() {
	return useRequiredContext(CheckoutContext, 'CheckoutContext');
}
